import { render, staticRenderFns } from "./select2.vue?vue&type=template&id=0bb32141&lang=pug"
import script from "./select2.vue?vue&type=script&lang=js"
export * from "./select2.vue?vue&type=script&lang=js"
import style0 from "./select2.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports